import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GET, PATCH, POST, PUT } from "../../services/axiosInstance";
import { route } from "../../services/apiRoutes";

const initialState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  error: null,
  activeStep: null, // while reseting set null
  applicantActiveStep: 0,
  applicantTotal: 0,
  createBookingData: {},
  enquiryDetails: {},
  applicantData: {},
  applicantPdf: {},
  termsAndCondition: {},
  masterData: {},
  showUploadProfileImage: false,
  showUploadPanImage: false,
  showUploadPassportImage: false,
  showUploadOCIImage: false,
  showUploadOCIAlternateImage: false,
  showUploadAadharImage: false,
  referralList:[],
  reviewActiveStep : 0,
  showReferralModal : false,
  showMobileStepper: false,
  isAgreedOnTerms : false,
  isFromPreview : {value : false, index : null },
  stepsCompleted: {},
  showPhysicalProfileImage: false,
  showPhysicalPanImage: false,
  showPhysicalPassportImage: false,
  showPhysicalOCIImage: false,
  showPhysicalOCIAlternateImage: false,
  showPhysicalAadharImage: false,
  projectBrandImage : '',
  applicantEditPreview:false,
  checkFirstStepCompleted: false,
  applicantActiveStep1: 0,
  applicantActiveStep2: 0,
  referralDetails: {},
  eSignature: false,
  offline: false, 
  EOIBooking:false,
  stepEOI: 0,
  showUploadPaymentProofImage: false,
  bookingDocuments: {},
  showUploadGSTCertificate: false,
};

export const getApplicantDetails = createAsyncThunk(
  "applicantData",
  async (payload, thunkAPI) => {
    try {
      const res = await GET(route.GET_BOOKING_DATA, payload);
      if (res?.response?.success) {
        return res?.response?.response?.data || {};
      } else {

      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const getApplicantPdf = createAsyncThunk(
  "applicantPdf",
  async (payload, thunkAPI) => {
    try {
      const res = await GET(route.GET_BOOKING_PDF, payload);
      if (res?.response?.success) {
        return res?.response?.response?.data || {};
      } else {

      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const createBooking = createAsyncThunk(
  "createBooking",
  async (payload, thunkAPI) => {
    try {
      const res = await POST(route.CREATE_BOOKING_API, payload);
      if (res?.response?.success) {
        thunkAPI.dispatch(setActiveStep(0));
        thunkAPI.dispatch(getApplicantDetails(`/${payload?.opportunityId}`))
        return res?.response?.response?.data || {};
      } else {

      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const getOppprtunityDetails = createAsyncThunk(
  "enquiryDetails",
  async (payload, thunkAPI) => {
    try {
      const res = await GET(route.GET_OPPORTUNITY_DETAILS, payload);
      if (res?.response?.success) {
        return res?.response?.response || {};
      } else {

      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const getReferralDetails = createAsyncThunk(
  "referralDetails",
  async (payload, thunkAPI) => {
    try {
      const res = await GET(route.REFERRAL_DETAILS, payload);
      if (res?.response.success) {
        return res?.response?.response?.data || {};
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const updateApplicantDetails = createAsyncThunk(
  "updateApplicantData",
  async (value, thunkAPI) => {
    try {
      const res = await PATCH(value?.path,value?.payload)
      if(res?.status === 200) {
        let state = thunkAPI.getState()
        let completedSteps = {
          ...state.stepsCompleted,
          [state?.customerForm?.activeStep]: true,
        }
        thunkAPI.dispatch(setStepsCompleted(completedSteps))
        if (!value?.freezeCurrentStep) {        
          thunkAPI.dispatch(setActiveStep(state?.customerForm?.activeStep + 1));
        }     
        thunkAPI.dispatch(getApplicantDetails(`/${value?.opportunityId}`))
        return res?.response

      } 
      if(res?.status === 400 || res?.status === 404 || res?.status === 500) {
        console.log('error', res)
      }
    
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);
export const updateDocumentCommentDetails = createAsyncThunk(
  "updateDocumentCommentDetails",
  async (value, thunkAPI) => {
    try {
      const res = await PATCH(value?.path,value?.payload)
      if(res?.status === 200) {
        let state = thunkAPI.getState()
        let completedSteps = {
          ...state.stepsCompleted,
          [state?.customerForm?.activeStep]: true,
        }
        thunkAPI.dispatch(setStepsCompleted(completedSteps))
          thunkAPI.dispatch(setActiveStep(state?.customerForm?.activeStep + 1));
        thunkAPI.dispatch(getApplicantDetails(`/${value?.opportunityId}`))
        return res?.response

      } 
      if(res?.status === 400 || res?.status === 404 || res?.status === 500) {
        console.log('error', res)
      }
    
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);
export const updateOtherDetails = createAsyncThunk(
  "updateOtherDetails",
  async (value, thunkAPI) => {
    try {
      const res = await PATCH(value?.path,value?.payload)
      if(res?.status === 200) {
        let state = thunkAPI.getState()
        let completedSteps = {
          ...state.stepsCompleted,
          [state?.customerForm?.activeStep]: true,
        }
        thunkAPI.dispatch(setStepsCompleted(completedSteps))
          thunkAPI.dispatch(setActiveStep(state?.customerForm?.activeStep + 1));

        thunkAPI.dispatch(getApplicantDetails(`/${value?.opportunityId}`))
        return res?.response
      } 
      if(res?.status === 400 || res?.status === 404 || res?.status === 500) {
        console.log('error', res)
      }
    
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);
// funtion for applicant 1 to 4 steps
export const updateApplicantDetailsForm = createAsyncThunk(
  "updateApplicantDetailsForm",
  async (value, thunkAPI) => {   
    try {
      const res = await PATCH(value?.path, value?.payload);
      if (res?.status === 200) {
        let state = thunkAPI.getState();
        thunkAPI.dispatch(
          setApplicantActiveStep(state?.customerForm?.applicantActiveStep + 1)
        );
        thunkAPI.dispatch(
          getApplicantDetails(`/${value?.opportunityId}`)
        );
        return res;
      }
      if (res?.status === 400 || res?.status === 404 || res?.status === 500) {
        console.log("error", res);
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const createReferrals = createAsyncThunk(
  "createReferrals",
  async (payload, thunkAPI) => {
    try {
      const res = await POST(route.CREATE_REFERRALS, payload);
      if (res?.status === 201) {
        return res.response;
      }
      if (res?.status === 400 || res?.status === 404 || res?.status === 500) {
        console.log("error", res);
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const getTermsAndCondition = createAsyncThunk(
  "termsAndCondition",
  async (payload, thunkAPI) => {
    try {
      const res = await GET(route.GET_TERMS_AND_CONDITION, payload);
      if (res?.response?.success) {
        return res?.response?.response?.data || {};
      } else {

      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const getMasterDataList = createAsyncThunk(
  "getMasterDataList",
  async (payload, thunkAPI) => {
    try {
      const res = await GET(route.GET_MASTER_DATA, payload);
      if (res?.response?.success) {
        return res?.response?.response?.data || {};
      } else {

      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const updateReviewDetails = createAsyncThunk(
  "updateReviewDetails",
  async (value, thunkAPI) => {
    try {
      const res = await PATCH(value?.path, value?.payload);
      if (res?.status === 200) {
                let state = thunkAPI.getState();

        if(value?.stepsLenght === 3) {
        thunkAPI.dispatch(
          setReviewActiveStep(state?.customerForm?.reviewActiveStep + 1)
        );
        thunkAPI.dispatch(
          getApplicantDetails(`/${value?.opportunityId}`)
        );
        } else{
     let completedSteps = {
          ...state.stepsCompleted,
          [state?.customerForm?.activeStep]: true,
        }
        thunkAPI.dispatch(setStepsCompleted(completedSteps))
        if (!value?.freezeCurrentStep) {        
          thunkAPI.dispatch(setActiveStep(state?.customerForm?.activeStep + 1));
        }     
        thunkAPI.dispatch(getApplicantDetails(`/${value?.opportunityId}`))
        }
       
        return res?.response;
      } else {
        if (res?.status === 400 || res?.status === 404 || res?.status === 500) {
          console.log("error", res);
        }
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const updateSaveForLater = createAsyncThunk(
  "updateSaveForLater",
  async (value, thunkAPI,) => {
    try {
       const { path, payload, opportunityId, method = "PATCH" } = value;
   let res;

      if (method === "POST") {
        res = await POST(path, payload);
      } else {
        res = await PATCH(path, payload);
      }
      if (res?.status === 200) {
        thunkAPI.dispatch(
          getApplicantDetails(`/${opportunityId}`)
        );
        return res?.response;
      } else {
        if (res?.status === 400 || res?.status === 404 || res?.status === 500) {
          console.log("error", res);
        }
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const updateReviewAndSign = createAsyncThunk(
  "updateReviewAndSign",
  async (value, thunkAPI) => {
    try {
      const res = await PATCH(value?.path,value?.payload)
      if(res?.status === 200) {
        let state = thunkAPI.getState()
        state.isAgreedOnTerms = value?.payload?.isAgreedOnTerms
        thunkAPI.dispatch(getApplicantDetails(`/${value?.opportunityId}`))
       return res?.response
      } else {
        if(res?.status === 400 || res?.status === 404 || res?.status === 500) {
          console.log('error', res)
        }
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const getPresignedUrl = createAsyncThunk(
  "getPresignedUrl",
  async (payload, thunkAPI) => {
    try {
      const res = await POST(route.GET_PRESIGNED_URL, payload);
      if (res?.response?.success) {
        return res?.response?.response;
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const uploadFile = createAsyncThunk(
  "uploadFile",
  async (payload, thunkAPI) => {
    try {
      const res = await PUT(payload.presignedUrl, payload.file, {
        headers: {
          'Content-Type': payload.file.type,
        },
      });
      if (res?.response?.status === 200) {
        return res?.response;
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const deleteImage = createAsyncThunk(
  "deleteImage",
  async (payload, thunkAPI) => {
    try {
      const res = await POST(route.DELETE_IMAGE, payload);
      if (res?.response?.success) {
        return res?.response;
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const updateImageData = createAsyncThunk(
  "updateImageData",
  async (payload, thunkAPI) => {
    try {
      const res = await POST(route.UPDATE_DELETE_IMAGE, payload)
      if(res?.status === 201) {
        thunkAPI.dispatch(getApplicantDetails(`/${payload?.oppId}`))
        return res?.response
      } 
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const signForApplicant = createAsyncThunk(
  "signForApplicant",
  async (value, thunkAPI) => {
    try {
      const res = await POST(value?.path,value?.payload)
      // if(res?.status === 200 || res?.status === 201) {
      //  return res?.response
      // } else {
      //   if(res?.status === 400 || res?.status === 404 || res?.status === 500) {
      //     console.log('error', res)
      //   }
      // }
      if(res?.response?.success) {
         return res?.response?.response;
        } else {

        }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const saveRatingFeedback = createAsyncThunk(
  "saveRatingFeedback",
  async (payload, thunkAPI) => {
    try {
      const res = await POST(route.SAVE_RATING_FEEDBACK, payload);
      if (res?.response?.success) {
        return res?.response?.response;
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);
export const deleteBooking = createAsyncThunk(
  "deleteBooking",
  async (payload, thunkAPI) => {
    try {
      const res = await POST(route.DELETE_BOOKING, payload);
      if (res?.response?.success) {
        return res?.response?.response;
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const getBookingDocuments = createAsyncThunk(
  "getBookingDocuments",
  async (payload, thunkAPI) => {
    try {
      const res = await GET(route.GET_BOOKING_DOCUMENTS, payload);
      if (res?.response?.success) {
        return res?.response?.response?.data || {};
      } else {

      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);
export const updateReferralDetails = createAsyncThunk(
  "updateReferralData",
  async (value, thunkAPI) => {
    try {
      const res = await POST(value?.path,value?.payload)
      if(res?.status === 200) {
        let state = thunkAPI.getState()
        let completedSteps = {
          ...state.stepsCompleted,
          [state?.customerForm?.activeStep]: true,
        }
        thunkAPI.dispatch(setStepsCompleted(completedSteps))
        thunkAPI.dispatch(getApplicantDetails(`/${value?.opportunityId}`))
        return res?.response?.response
      } 
      if(res?.status === 400 || res?.status === 404 || res?.status === 500) {
        console.log('error', res)
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);
export const customerFormSlice = createSlice({
  name: "customerForm",
  initialState,
  reducers: {
    clearState: () => initialState,
    setActiveStep: (state, action) => {
      state.activeStep = action.payload;
    },
    setApplicantActiveStep: (state, action) => {
      state.applicantActiveStep = action.payload;
    },
    setApplicantTotal: (state, action) => {
      state.applicantTotal = action.payload;
    },
    setShowUploadProfileImage: (state, action) => {
      state.showUploadProfileImage = action.payload;
    },
    setShowUploadPanImage: (state, action) => {
      state.showUploadPanImage = action.payload;
    },
    setShowUploadOCIImage: (state, action) => {
      state.showUploadOCIImage = action.payload;
    },
    setShowUploadOCIAlternateImage: (state, action) => {
      state.showUploadOCIAlternateImage = action.payload;
    },
    setShowUploadPassportImage: (state, action) => {
      state.showUploadPassportImage = action.payload;
    },
    setShowUploadAadharImage: (state, action) => {
      state.showUploadAadharImage = action.payload;
    },
    setReferralList: (state, action) => {
      state.referralList = action.payload;
    },
    setReviewActiveStep: (state, action) => {
      state.reviewActiveStep = action.payload;
    },
    setIsError: (state, action) => {
      state.isError = action.payload;
    },
    setShowMobileStepper: (state, action) => {
      state.showMobileStepper = action.payload;
    },
    setShowReferralModal: (state, action) => {
      state.showReferralModal = action.payload
    },
    setCheckFirstStepCompleted: (state, action) => {
      state.checkFirstStepCompleted = action.payload
    },
    setApplicantActiveStep1: (state, action) => {
      state.applicantActiveStep1 = action.payload
    },
    setApplicantActiveStep2: (state, action) => {
      state.applicantActiveStep2 = action.payload
    },
    setESignature: (state, action) => {
      state.eSignature = action.payload;
    },
    setOffline: (state, action) => {
      state.offline = action.payload;
    },
    setResetData: (state, action) => {
      state.activeStep = null
      state.applicantActiveStep = 0
      state.applicantActiveStep1 = 0
      state.applicantActiveStep2 = 0
      state.applicantTotal = 0
      state.reviewActiveStep = 0
      state.applicantData = {}
      state.showReferralModal = false
      state.isError = false
      state.isLoading = false
      state.projectBrandImage = ''
      state.showUploadProfileImage = false
      state.showUploadPanImage = false
      state.showUploadPassportImage = false
      state.showUploadOCIImage = false
      state.showUploadOCIAlternateImage = false
      state.showUploadAadharImage = false
      state.applicantEditPreview = false
      state.showUploadPaymentProofImage = false
      state.showUploadGSTCertificate = false
    },
    setIsFromPreview: (state, action) => {
      state.isFromPreview = action.payload
    },
    setStepsCompleted: (state, action) => {
      state.stepsCompleted = action.payload
    },
    setShowPhysicalProfileImage: (state, action) => {
      state.showPhysicalProfileImage = action.payload;
    },
    setShowPhysicalPanImage: (state, action) => {
      state.showPhysicalPanImage = action.payload;
    },
    setShowPhysicalOCIImage: (state, action) => {
      state.showPhysicalOCIImage = action.payload;
    },
    setShowPhysicalOCIAlternateImage: (state, action) => {
      state.showPhysicalOCIAlternateImage = action.payload;
    },
    setShowPhysicalPassportImage: (state, action) => {
      state.showPhysicalPassportImage = action.payload;
    },
    setShowPhysicalAadharImage: (state, action) => {
      state.showPhysicalAadharImage = action.payload;
    },
    setProjectBrandImage: (state, action) => {
      state.projectBrandImage = action.payload;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setEditPreviewApplicant: (state,action) => {
      state.applicantEditPreview= action.payload
    },
    setEOIBooking:(state,action) => {
      state.EOIBooking =action.payload
    },
    setStepEOI:(state,action) => {
      state.stepEOI = action.payload
    },
    setShowUploadPaymentProofImage: (state, action) => {
      state.showUploadPaymentProofImage = action.payload;
    },
    setShowUploadGSTCertificate: (state, action) => {
      state.showUploadGSTCertificate = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getApplicantDetails.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getApplicantDetails.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.isSuccess = true;
      state.applicantData = action.payload;
    });
    builder.addCase(getApplicantDetails.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.error = action.payload.error;
    });
    builder.addCase(getApplicantPdf.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getApplicantPdf.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.isSuccess = true;
      state.applicantPdf = action.payload;
    });
    builder.addCase(getApplicantPdf.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.error = action.payload.error;
    });
    builder.addCase(createBooking.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(createBooking.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.isSuccess = true;
      state.createBookingData = action.payload;
    });
    builder.addCase(createBooking.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.error = action?.payload?.message;
    });
    builder.addCase(getOppprtunityDetails.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getOppprtunityDetails.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.isSuccess = true;
      state.enquiryDetails = action.payload;
    });
    builder.addCase(getOppprtunityDetails.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.error = action.payload.error;
    });
    builder.addCase(getReferralDetails.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getReferralDetails.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.isSuccess = true;
      state.referralDetails = action.payload;
    });
    builder.addCase(getReferralDetails.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.error = action.payload.error;
    });
    builder.addCase(updateApplicantDetails.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(updateApplicantDetails.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.isSuccess = true;
    });
    builder.addCase(updateApplicantDetails.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.error = action.payload.error;
    });

    builder.addCase(createReferrals.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(createReferrals.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.isSuccess = true;
    });
    builder.addCase(createReferrals.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.error = action.payload.error;
    });
    builder.addCase(getTermsAndCondition.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getTermsAndCondition.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.isSuccess = true;
      state.termsAndCondition = action.payload;
    });
    builder.addCase(getTermsAndCondition.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.error = action.payload.error;
    });
    builder.addCase(getMasterDataList.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getMasterDataList.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.isSuccess = true;
      state.masterData = action.payload;
    });
    builder.addCase(getMasterDataList.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.error = action?.payload?.error;
    });
    builder.addCase(updateApplicantDetailsForm.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(updateApplicantDetailsForm.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.isSuccess = true;
    });
    builder.addCase(updateApplicantDetailsForm.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.error = action.payload.error;
    });
    builder.addCase(updateReviewDetails.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(updateReviewDetails.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.isSuccess = true;
    });
    builder.addCase(updateReviewDetails.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.error = action.payload.error;
    });
    builder.addCase(updateReviewAndSign.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(updateReviewAndSign.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.isSuccess = true;
    });
    builder.addCase(updateReviewAndSign.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.error = action.payload.error;
    });
    builder.addCase(signForApplicant.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(signForApplicant.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.isSuccess = true;
    });
    builder.addCase(signForApplicant.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.error = action.payload.error;
    });
    builder.addCase(saveRatingFeedback.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(saveRatingFeedback.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.isSuccess = true;
    });
    builder.addCase(saveRatingFeedback.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.error = action.payload.error;
    });
    builder.addCase(deleteBooking.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(deleteBooking.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.isSuccess = true;
    });
    builder.addCase(deleteBooking.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.error = action.payload.error;
    });
    builder.addCase(getBookingDocuments.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getBookingDocuments.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.isSuccess = true;
      state.bookingDocuments = action.payload;
    });
    builder.addCase(getBookingDocuments.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.error = action.payload.error;
    });
    
    
    
  },
});

export const {
  clearState,
  setActiveStep,
  setApplicantActiveStep,
  setApplicantTotal,
  setShowUploadProfileImage,
  setReferralList,
  setReviewActiveStep,
  setIsError,
  setShowMobileStepper,
  setShowReferralModal,
  setResetData,
  setShowUploadAadharImage,
  setShowUploadPanImage,
  setShowUploadPassportImage,
  setShowUploadOCIImage,
  setShowUploadOCIAlternateImage,
  setIsFromPreview,
  setStepsCompleted,
  setShowPhysicalProfileImage,
  setShowPhysicalPanImage,
  setShowPhysicalOCIImage,
  setShowPhysicalOCIAlternateImage,
  setShowPhysicalPassportImage,
  setShowPhysicalAadharImage,
  setProjectBrandImage,
  setIsLoading,
  setEditPreviewApplicant,
  setCheckFirstStepCompleted,
  setApplicantActiveStep1,
  setApplicantActiveStep2,
  setESignature, 
  setOffline,
  setEOIBooking,
  setStepEOI,
  setShowUploadPaymentProofImage,
  setShowUploadGSTCertificate,
} = customerFormSlice.actions;
export default customerFormSlice.reducer;
